import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/motion";
import { PROGRAMS } from "@/data/content";

const Programs = () => {
  const scrollToForm = () => document.getElementById("admissions")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="programs" className="bg-sand py-24 md:py-36 scroll-mt-24">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-16">
          <Reveal className="md:col-span-8">
            <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Our Programs</p>
            <h2 className="font-serif text-4xl md:text-6xl text-forest tracking-tight leading-[1.02]">
              Care that meets you <span className="italic text-terracotta">exactly</span> where you are
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-4">
            <p className="text-ink2 leading-relaxed">
              From your first day of treatment to a lifetime of support, every program is built around the
              individual — not a formula.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {PROGRAMS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.id} delay={i * 0.12}>
                <button
                  onClick={scrollToForm}
                  data-testid={`program-${p.id}`}
                  className="group text-left w-full h-full rounded-3xl bg-white border border-line overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] transition-shadow duration-500"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <span className="absolute top-4 left-4 grid place-items-center w-11 h-11 rounded-full bg-sand/90 text-forest">
                      <Icon className="w-5 h-5" />
                    </span>
                  </div>
                  <div className="p-7">
                    <p className="text-xs uppercase tracking-[0.2em] text-terracotta mb-2">{p.tagline}</p>
                    <div className="flex items-center justify-between gap-3">
                      <h3 className="font-serif text-2xl md:text-3xl text-forest">{p.name}</h3>
                      <ArrowUpRight className="w-6 h-6 text-terracotta shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                    </div>
                    <p className="mt-4 text-ink2 leading-relaxed">{p.desc}</p>
                  </div>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Programs;
